export const termsAndconditions = [
  'Fare rules of your new ticket will be the same as on your old ticket.',
  'Airline fee - to be advised.',
  'Luxury Escapes reduced service fee - $25 AUD per person, per ticket.',
  'New fare must be equal or higher.',
  'Fare and/or tax difference (if any) will need to be paid by the customer.',
  'Your new flight must depart from the same country as was shown on your original ticket.',
  'Value of your ticket credit cannot be used on partner airlines (codeshare).',
  'Value of your ticket credit must be used in a single transaction.',
  'Name on your new flight ticket must be the same as on your old ticket.',
  'Value of your ticket credit is non-refundable, non-transferrable, and non-combinable.',
  'Your airline credit comes with a travel-by date. Please ensure to check this information on the credit confirmation that was previously sent to you.',
  'Airline credit conditions are subject to change without prior notice.',
]

export const errorDetails = {
  invalidInput: 'Please reconfirm your details and try again, or contact our flight support team for assistance.',
  duplicateBooking: 'If you wish to modify your booking or add more flights with your credit, please contact our customer support team.',
}
